export default {
  name: 'dates-pop-up',
  props: ['showPopUp'],
  data() {
    return {
      actualYear: null,
      actualMonth: null,
      actualDay: null,
      activeDay: false,
      choosedDate: {
        day: null,
        months: null,
        years: null
      },
      allYears: [],
      allDays: [],
      months: ["STY", "LUT", "MAR", "KWI", "MAJ", "CZE", "LIP", "SIE", "WRZ", "PAŹ", "LIS", "GRU"]
    }
  },
  computed: {
    showMonth() {
      return this.months[this.actualMonth]
    }
  },
  methods: {
    checkIfLeapYear(value) {
      if (value%4 === 0) {
        if(value%100 !== 0) {
          return true;
        }
        if(value%100 === 0 && value%400 === 0) {
          return true;
        } else if(value%100 === 0 && value%400 !== 0) {
          return false;
        }
      } else {
        return  false;
      }
    },
    checkIf31(value) {
      if(value === 0) {
        return true;
      } else if (value === 2) {
        return true;
      } else if (value === 4) {
        return true;
      } else if (value === 6) {
        return true;
      } else if (value === 7) {
        return true;
      } else if (value === 9) {
        return true;
      } else if (value === 11) {
        return true;
      } else {
        return false;
      }

    },
    emitDay(value) {
      this.actualDay = value;
      this.choosedDate.day = value;
    },
    changeActualYear(value) {
      this.actualYear = value;
      this.choosedDate.years = value;
      this.makeDateValue(this.actualMonth);
    },
    makeDateValue(value) {
      let monthIndex;
      if(typeof(value)==="number") {
        monthIndex = value;
      } else {
        monthIndex = this.months.indexOf(value);
      }
      this.actualMonth = monthIndex;
      this.choosedDate.months = monthIndex;
      let monthsDays;
      if(monthIndex === 1) {
        if (this.checkIfLeapYear(this.actualYear)) {
          monthsDays = 29
        } else {
          monthsDays = 28
        }
      } else if(this.checkIf31(monthIndex)) {
        monthsDays = 31;
      } else {
        monthsDays = 30;
      }
      this.allDays = [];
      for(let i = 1; i <= monthsDays; i++ ){
        this.allDays.push(i);
      }
      this.activeDay = true;
    },
    sendInfoToList() {
      this.$emit('dateInfo', this.choosedDate);
      this.closePopUp();
    },
    closePopUp() {
      this.$emit('close');
    }
  },
  mounted() {
    const today = new Date();
    this.actualYear = today.getFullYear();
    this.actualMonth = today.getMonth();
    this.actualDay = today.getDate();
    this.choosedDate = {
      day: this.actualDay,
      months: this.actualMonth,
      years: this.actualYear
    }
    this.makeDateValue(this.actualMonth);
    const firstYear = 1982;
    for (let i = this.actualYear; i >= firstYear; i--) {
      this.allYears.push(i);
    }
  }
}
